<medsurf-chapter [hidden]="isSlide() === true"></medsurf-chapter>
<medsurf-slide [hidden]="isSlide() === false"></medsurf-slide>